import axios from './axios';
import Message from "@/components/Message/index";

const isDev = process.env.NODE_ENV === "development";
// const baseUrl = isDev ? 'https://testmail.dmail.ai' : 'https://pay.dmail.ai'
const baseUrl = 'https://pay.dmail.ai'

const remainDecimalByString = (num, digits = 2) => {
  if (!/^[0-9]+.?[0-9]*$/.test(num + "")) {
    return num;
  }
  const n = Math.pow(10, digits);
  const nn = Math.round(+num * n) / n
  if (/.+\.\d$/.test(`${nn}`)) {
    return `${nn}0`
  } else if (/^[^\.]+$/.test(`${nn}`)) {
    return `${nn}.00`
  }
  return nn;
};

const getMillionNumOrNot = (num) => {
  if (typeof num !== 'number') {
    return [0, '']
  }
  return num / 1000000 > 1 ? [remainDecimalByString(num / 1000000), 'M'] : [num, '']
}

export const getHomeData = async () => {
  try {
    const res = await axios({
      url: 'https://icp.dmail.ai/api/node/v6/dmail/statistics/portal',
      method: 'get',
      // errorTitle: '',
    })
    const { code, data, message, success } = res.data
    return data && data.nft_count ? {
      subProjectCount: data.projects_count > 0 ? Math.floor(data.projects_count /10) * 10 : 0,
      nfts: getMillionNumOrNot(data.nft_count),
      messages: getMillionNumOrNot(data.message_count),
      transactions: getMillionNumOrNot(data.transaction_count),
      users: getMillionNumOrNot(data.user_count),
    } : null
  } catch (error) {
    return null
  }
}


export const getSubData = async () => {
  try {
    const res = await axios({
      url: 'https://subapi.dmail.ai/dmailSubHub/officialWebsite/getSubHubData',
      method: 'get',
      // errorTitle: '',
    })
    const { code, data, message, success } = res.data
    return data && 'messagesCount' in data ? {
      messages: getMillionNumOrNot(+data.messagesCount),
      projects: getMillionNumOrNot(+data.onboardedProjects),
      subscribers: getMillionNumOrNot(+data.subscriberCount),
    } : null
  } catch (error) {
    return null
  }
}

export const getStakeData = async () => {
  try {
    const res = await axios({
      url: 'https://icp.dmail.ai/dmailServer/api/stake/getInfo',
      method: 'get',
      // errorTitle: '',
    })
    const { code, data, message, success } = res.data
    const { stakePeriods, dmailPrice, totalRewards, totalStaked } = data
    return {
      period: stakePeriods,
      price: dmailPrice ? `$${dmailPrice}` : '',
      staked: totalStaked,
      rewards: totalRewards,
    }
  } catch (error) {
    return {}
  }
}

export const getTypes = async () => {
  return []

  // try {
  //   const res = await axios({
  //     url: 'https://sdk.dmail.ai/platform/api/v1/projects/type/name',
  //     method: 'get',
  //     // errorTitle: '',
  //   })
  //   const { code, data: { list }, message, success } = res.data
  //   return Array.isArray(list) ? list : []
  // } catch (error) {
  //   return []
  // }
}

export const getCenterList = async (type, name = '', page = 0, pageSize = 30) => {
  const params = name ? { project_name: name } : {}
  try {
    const res = await axios({
      url: 'https://icp.dmail.ai/api/node/v6/dmail/subhub/project_by_pager',
      method: "post",
      data: {
        type,
        ...params,
        order: 'desc',
        pageInfo: { page: page + 1, pageSize }
      }
    });
    const { msg, success, data: { list, totalCount } } = res.data;
    return {
      list: Array.isArray(list) ? list : [],
      total: totalCount
    }
  } catch (error) {
    console.log('error', error)
    return {
      list: []
    };
  }
}

export const subscribeNews = async (email) => {
  try {
    const res = await axios({
      url: `${baseUrl}/sublist`,
      data: {
        email
      },
      method: 'post',
    })
    const { code, data, message, success } = res.data
    return { code, success, msg: message, data }
  } catch (error) {
    console.log('error', error)
    return { success: false, msg: error, data: null }
  }
}

export const ambassadorApply = async (data) => {
  try {
    const res = await axios({
      url: `${baseUrl}/ambassador`,
      data: data,
      method: 'post',
      // errorTitle: '',
    })
    return { ...res.data, msg: res.data.message }
  } catch (error) {
    console.log('error', error)
    return { success: false, msg: error, data: null }
  }
}

export const login = async (address) => {
  return axios({
    url: `${baseUrl}/login`,
    method: 'post',
    data: {
      address,
    },
    // errorTitle: '',
  }).then((res) => {
    try {
      const { code, data, message, success } = res.data
      return { success, msg: message, data }
    } catch (error) {
      return { success: false, msg: error, data: null }
    }
  })
}

export const verifySign = async (address, signature) => {
  return axios({
    url: `${baseUrl}/auth`,
    method: 'post',
    data: {
      address,
      signature,
    },
    // errorTitle: '',
  }).then((res) => {
    try {
      const { code, data, message, success } = res.data
      return { success, msg: message, data }
    } catch (error) {
      return { success: false, msg: error, data: null }
    }
  })
}

export const checkAuth = async (options = {}) => {
  try {
    const res = await axios({
      url: `/products/checksale`,
      method: "post",
      data: {
        options: JSON.stringify(options),
      }
    });
    const { msg, success, data } = res.data;
    return success
  } catch (error) {
    // Message.error('Get data failed')
    return false;
  }
};

export const searchEmail = async (key) => {
  // try {
  //   const res = await axios({
  //     url: `${baseUrl}/products`,
  //     method: "post",
  //     data: {
  //       key,
  //     },
  //   });
  //   const { msg, success, data } = res.data;
  //   if (success && data) {
  //     return data;
  //   } else {
  //     return false;
  //   }
  // } catch (error) {
  //   Message.error('Get data failed')
  //   return null;
  // }
};

export const getEmailInfo = async (key) => {
  // try {
  //   const res = await axios({
  //     url: `${baseUrl}/products/detail`,
  //     method: "post",
  //     data: {
  //       key,
  //     },
  //   });
  //   const { msg, success, data } = res.data;
  //   if (success && data) {
  //     return data;
  //   } else {
  //     Message.error(msg || 'Get data failed')
  //     return null;
  //   }
  // } catch (error) {
  //   Message.error('Get data failed')
  //   return null;
  // }
};

export const getIcpPrice = async (product_name) => {
  // try {
  //   const res = await axios({
  //     url: `${baseUrl}/icpprice`,
  //     method: "post",
  //     data: {
  //       product_name,
  //     }
  //   });
  //   const { msg, success, data } = res.data;
  //   if (Array.isArray(data)) {
  //     return data.reduce((res, { ori_price, symbal, price }) => {
  //       ori_price > 0 && (res.price = ori_price)
  //       res[symbal] = price
  //       return res
  //     }, {})
  //   }
  //   return {}
  // } catch (error) {
  //   // Message.error('Get data failed')
  //   return {}
  // }
};

export const blockEmail = async (product_name) => {
  // try {
  //   const res = await axios({
  //     url: `${baseUrl}/lockdomain`,
  //     method: "post",
  //     data: {
  //       product_name
  //     }
  //   });
  //   const { msg, success, data } = res.data;
  //   !success && Message.error(msg || 'Lock email failed')
  //   return success;
  // } catch (error) {
  //   Message.error('Lock email failed')
  //   return false;
  // }
};

export const getLockedTime = async (product_name) => {
  // try {
  //   const res = await axios({
  //     url: `${baseUrl}/timer/${product_name}`,
  //     method: "get",
  //   });
  //   const { msg, success, ttl } = res.data;
  //   return ['string', 'number'].includes(typeof ttl) ? +ttl : -100;
  // } catch (error) {
  //   return -100;
  // }
};

// const plugShim = (address, data) => {
//   if(data.address.indexOf('-')>0){
//     data = {
//       ...data,
//       is_verify: true
//     }
//   }
//   return data;
// }

export const detectPaySuccess = async (hash, from, loginAddress, price, product_name, jwt, network = '56', channel_id, wallet_name) => {
  // const testParams = {
  //   source_name: isDev ? 'dmailofficial' : '',
  //   wallet_name,
  // }
  // try {
  //   const res = await axios({
  //     url: `${baseUrl}/transfer`,
  //     method: 'post',
  //     data: {
  //       mail_address: loginAddress, price, product_name,
  //       jwt, network, channel_id,
  //       tx: hash, address: from,
  //       is_verify: true,
  //       ori_network: '',
  //       pid: '',
  //       ...testParams
  //     }
  //   });
  //   const { data, message, success } = res.data;
  //   !success && Message.error(message)
  //   return success
  // } catch (error) {
  //   Message.error(error || 'Payment failed')
  //   return false
  // }
}

export const detectMintSuccess = async (tx) => {
  // try {
  //   const res = await axios({
  //     url: `${baseUrl}/transferstatus`,
  //     method: 'post',
  //     data: {
  //       tx,
  //       is_verify: true,
  //     }
  //   });
  //   const { data, message, success } = res.data;
  //   // Message[success ? 'success' : 'error'](success ? 'Payment successful' : message)
  //   return { success, data, message }
  // } catch (error) {
  //   // Message.error(error || 'Payment failed')
  //   return { success: false, data: null, message: "Payment failed" }
  // }
}

export const receiveNft = async (address, plugAddress, id, jwt) => {
  // const params = jwt ? { jwt } : { is_verify: true }
  // try {
  //   const res = await axios({
  //     url: `${baseUrl}/receivenft`,
  //     method: 'post',
  //     data: {
  //       address, p_id: plugAddress, id,
  //       ...params,
  //     }
  //   });
  //   const { data, totalPages, message, success } = res.data;
  //   return { success, data, totalPages, message }
  // } catch (error) {
  //   return { success: false, data: null, message: "Get Data failed" }
  // }
}

export const getMyOrders = async (address, page, pageSize, jwt) => {
  const params = jwt ? { jwt } : { is_verify: true }
  try {
    const res = await axios({
      url: `${baseUrl}/trades`,
      method: 'post',
      data: {
        address, page, pageSize,
        ...params,
      }
    });
    const { data, totalPages, message, success } = res.data;
    return { success, data, totalPages, message }
  } catch (error) {
    return { success: false, data: null, message: "Get Data failed" }
  }
}

export const getTopReferrers = async (address, page, pageSize, jwt, network) => {
  const params = jwt ? { jwt } : { is_verify: true }
  try {
    const res = await axios({
      url: `${baseUrl}/usersrewards`,
      method: 'post',
      data: {
        address, page, pageSize, network,
        ...params,
      }
    });
    const { data, toplist, totalPages, totalCount, totalValus, totalTx, totalcommission, user_channel_id, message, success } = res.data;
    return { success, data, toplist, totalPages, totalCount, totalValus, totalTx, totalcommission, user_channel_id, message }
  } catch (error) {
    return { success: false, data: null, message: "Get Data failed" }
  }
}

export const invitation = async (dm_ralias) => {
  // try {
  //   return axios({
  //     url: `https://icp.dmail.ai/api/v3/mails/invitation`,
  //     data: {
  //       dm_ralias
  //     },
  //     method: 'post',
  //   }).then((res) => {
  //     const { code, data, msg, success } = res.data
  //     return { code, success, msg: msg, data }
  //   })
  // } catch (error) {
  //   return { success: false, msg: error, data: null }
  // }
}